module.exports = __webpack_public_path__ + "static/project.f3ca7bfa.svg";